export default __webpack_public_path__ + "static/media/avatar.091e4265.png";